<template>
  <div class="main">
    <van-nav-bar>
      <template #left>
        <van-icon name="arrow-left" size="20" color="#fff" @click="back()" />
      </template>
      <template #title>
        <span style="font-size: 1rem; color: #fff;">{{ xuanfeiInfo.xuanfei_name }}</span>
      </template>
      <template #right>
        <van-image @click="toKefu" :src="`/img/home/kefu.png`" width="24"></van-image>
      </template>
    </van-nav-bar>

    <div id="content">

      <div class="swiper">
        <van-swipe class="my-swipe" :show-indicators="false" @change="onChange" :autoplay="3000">
          <van-swipe-item v-for="(item, key) in xuanfeiList" :key=key>
            <van-image :src="item"></van-image>
          </van-swipe-item>
          <template #indicator>
            <div class="custom-indicator">{{ current + 1 }} / {{ xuanfeiList.length }}</div>
          </template>
        </van-swipe>
        <div class="swiper-fot">
          <van-image src="img/home/logo3.png?v=2" width="150" height="49" fit="contain"></van-image>
          <div class="renzheng">
            <div>{{ $t('xuanfeiDetail.label1') }}</div>
            <div>{{ $t('xuanfeiDetail.label2') }}</div>
          </div>
        </div>
      </div>

      <div class="code">
        <div>{{ xuanfeiInfo.xuanfei_name }}</div>
        <div>{{ xuanfeiInfo.number }}</div>
      </div>

      <div class="content">
        <div class="title">Girl Profile</div>
        <div class="row">
          {{ `${$t('xuanfeiDetail.label3')}：${xuanfeiInfo.height}cm ${$t('xuanfeiDetail.label4')}：${xuanfeiInfo.bust}` }}
        </div>
        <div class="biaoqian_wrap">
          <div class="biaoqian" v-for="(item, index) in xuanfeiInfo.type" :key="index">{{ item.name }}</div>
        </div>
        <div class="row">
          <div>
            <span>{{ $t('xuanfeiDetail.label5') }}：</span>
            <van-icon name="star" color="#f4b757" size="1.125rem" />
            <van-icon name="star" color="#f4b757" size="1.125rem" />
            <van-icon name="star" color="#f4b757" size="1.125rem" />
            <van-icon name="star" color="#f4b757" size="1.125rem" />
            <van-icon name="star" color="#f4b757" size="1.125rem" />
          </div>
        </div>
        <div class="flex">
          <div style="flex: 1">
            <div class="row">{{ `Available Service Area: ${xuanfeiInfo.diqu}` }}</div>
            <div class="row">{{ `Travel Available: ${xuanfeiInfo.diqu}` }}</div>
          </div>
          <div style="flex: 1" class="button2" @click="goGame">
            {{ $t('xuanfeiDetail.button') }}
          </div>
        </div>
        <div class="title" style="margin-top: 2rem;">{{ $t('xuanfeiDetail.title2') }}</div>

        <van-image v-for="(item, index) in xuanfeiList" :key="index" :src="item" style="margin-top: .3rem;"></van-image>
        <div class="title" style="margin-top: 0.63rem;">{{ $t('xuanfeiDetail.title3') }}</div>

        <div class="video_player">
          <video ref="video" class="video" controls playsinline webkit-playsinline preload="metadata" :autoplay = auto>
            <source :src="xuanfeiInfo.vod" />
          </video>
        </div>

        <div class="title2" style="font-size: 1.03rem; color: #534589;">{{ $t('xuanfeiDetail.title4') }}</div>
        <div class="row2" style="font-size: 0.97rem; color: #534589">{{ $t('xuanfeiDetail.text') }}</div>
      </div>
    </div>

    <van-popup v-model="windowShow" :style="{ width: '90%', height: '88%' }">
      <WindowLottery :detail="gameData" :window="true" />
    </van-popup>
  </div>
</template>


<script>
import "video.js/dist/video-js.css";
import WindowLottery from "../lottery/windowLottery.vue";
export default {
  components: { WindowLottery },
  data() {
    return {
      xuanfeiInfo: {},
      xuanfeiList: [],
      current: 0,
      auto: false,
      gameList: [],
      gameData: {},
      windowShow: false
    };
  },
  mounted() {
    this.getxuanfeidata()
    this.getGameItem()
    const userAgent = window.navigator.userAgent;
    const isMobile = /Mobile/i.test(userAgent);
    const isTablet = /Tablet/i.test(userAgent);
    this.auto = isMobile || isTablet
  },
  methods: {
    back() {
      return window.history.back();
    },
    onChange(index) {
      this.current = index
    },
    getxuanfeidata() {
      let data = JSON.parse(localStorage.getItem('xuanfeiDetail') || '{}')
      this.xuanfeiInfo = data
      this.xuanfeiList = data?.img_url
      console.log(data)
    },
    goGame() {
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        this.windowShow = true
      }
    },
    getGameItem(){
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res=>{
        let gameData = res.data[0]
        gameData.ico = this.xuanfeiInfo.img_url[0]
        console.log(gameData)
        this.gameData = gameData
      })
    },
    toKefu() {
      window.open(this.$store.getters.getBaseInfo.kefu)
    }
  }
};
</script>

<style lang="less" scoped>

.main {
  min-height: 100%;
  background: linear-gradient(180deg, #fff5f8 0%, #f8f3ff 55%, #fff6f0 100%);
}

.swiper {
  position: relative;
  height: 18rem;
  overflow: hidden;
  border-radius: 0 0 1.6rem 1.6rem;

  ::v-deep .van-image,
  ::v-deep .van-image__img,
  ::v-deep .van-swipe,
  ::v-deep .van-swipe-item {
    height: 18rem;
  }
  ::v-deep .van-image__img {
    object-fit: cover;
  }

  .swiper-fot {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: auto;
    min-height: 2.8rem;
    background: linear-gradient(180deg, rgba(74, 40, 80, 0) 0%, rgba(74, 40, 80, 0.55) 100%);
    border-radius: 0;
    z-index: 9;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 1.2rem 4% 0.7rem;
  }

  .renzheng {
    display: flex;

    div {
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.88);
      color: #8a63c9;
      border-radius: 1rem;
      font-weight: 600;
      margin-left: .2rem;
      padding: .2rem .6rem;
      font-size: .75rem;

      &::before {
        content: '';
        width: 1rem;
        height: 1rem;
        background: url('/public/img/home/icon.png');
        background-size: 100% 100%;
      }

      &:first-child,
      &:last-child {
        border-radius: 1rem;
      }
    }

  }

  .custom-indicator {
    color: #fff;
    text-align: right;
    padding-right: .66667rem;
    top: auto;
    bottom: 3.2rem;
    position: absolute;
    right: 0;
  }
}

.code {
  display: flex;
  width: 92%;
  margin: -1.4rem auto 0;
  position: relative;
  z-index: 3;
  background: #fff;
  border-radius: 1.15rem 1.15rem 0 0;
  box-shadow: 0 -0.3rem 0.8rem rgba(183, 156, 236, 0.12);
  height: 3.25rem;
  align-items: center;
  justify-content: flex-start;
  padding: 0 0.9rem;
  color: #4a3a5c;

  div {
    font-weight: bold;

    &:first-child {
      font-size: 1.13rem;
      margin-right: 0.63rem;
    }

    &:last-child {
      font-size: 1rem;
    }
  }
}

.content {
  width: 92%;
  margin: 0 auto 2rem;
  background-color: #fff;
  border-radius: 0 0 1.15rem 1.15rem;
  box-shadow: 0 0.4rem 1.1rem rgba(183, 156, 236, 0.14);
  padding: 0.4rem 0.9rem 1rem;

  .title {
    font-size: 1.19rem;
    padding-bottom: 1rem;
  }

  .row {
    font-size: 0.83rem;
    color: #333;
    margin: 0.38rem 0;
  }


  .biaoqian_wrap {
    display: flex;
    flex-wrap: wrap;
    margin: 0.3rem 0 0 0;

    .biaoqian {
      background: #ffeaf1;
      color: #e0739b;
      border: 1px solid rgba(245, 154, 184, 0.55);
      display: inline-block;
      border-radius: 2rem;
      margin-right: .33333rem;
      font-size: 12PX;
      padding: .33333rem 1rem;
      margin-bottom: .33333rem;
    }
  }

  .video_player {
    .video {
      width: 100%;
    }
  }

  .title2 {
    padding-top: 1rem;
    font-weight: bold;
  }

  .row2 {
    padding: .67rem 0;
  }

  .flex {
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .button2 {
    background: linear-gradient(120deg, #f7a1c0 0%, #c3a3f2 55%, #ffbe9c 100%);
    color: #fff;
    text-align: center;
    padding: 0.55rem 1rem;
    border-radius: 0.9rem;
    height: auto;
    position: static;
    width: 100%;
    margin-top: 0.7rem;
    font-size: 0.92rem;
    box-shadow: 0 0.25rem 0.8rem rgba(245, 154, 184, 0.3);
  }
}
</style>